export function isTitleNode(node) {
	return node && node.type.name === "title";
}

export function isBulletListNode(node) {
	return node && node.type.name === "bulletList";
}

export function isOrderedListNode(node) {
	return node && node.type.name === "orderedList";
}

export function isTodoListNode(node) {
	return node && node.type.name === "taskList";
}

export function isListNode(node) {
	return isBulletListNode(node) || isOrderedListNode(node) || isTodoListNode(node);
}

export function getCurrentNode(state) {
	const $head = state.selection.$head;
	let node = null;

	for (let d = $head.depth; d > 0; d--) {
		node = $head.node(d);
	}

	return node;
}

export function getNodeAtPos(state, pos) {
	const $head = state.doc.resolve(pos);
	let node = null;

	for (let d = $head.depth; d > 0; d--) {
		node = $head.node(d);
	}

	return node;
}

export function isInCustomNode(state, nodeName) {
	if (!state.schema.nodes[nodeName]) return false;

	const $head = state.selection.$head;
	for (let d = $head.depth; d > 0; d--) {
		if ($head.node(d).type === state.schema.nodes[nodeName]) {
			return true;
		}
	}
	return false;
}

export function isInCodeBlock(state) {
	return isInCustomNode(state, "codeBlock");
}

export function isInTitle(state) {
	if (state?.selection?.$head?.pos === 0) return true;
	return isInCustomNode(state, "title");
}

export function isInCallout(state) {
	return isInCustomNode(state, "callout");
}

export function findNode(editor, name) {
	const content = editor.getJSON();
	const queue = [content];
	const res = [];

	while (queue.length) {
		const node = queue.shift();

		if (node.type === name) {
			res.push(node);
		}

		if (node.content && node.content.length) {
			queue.push(...node.content);
		}
	}

	return res;
}
